var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 700,
    viewBox: "0 0 1440 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4204_47040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -254,
    width: 1580,
    height: 1154
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -253.194,
    width: 1580,
    height: 1152.23,
    fill: "url(#paint0_linear_4204_47040)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4204_47040)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: -13.1943,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 26.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 66.8057,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 106.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 146.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 186.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 226.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 266.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 306.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 346.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 386.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 426.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 466.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 506.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 546.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 586.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 626.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 666.806,
    width: 40,
    height: 40,
    fill: "#06202C",
    fillOpacity: 0.05,
    stroke: "#06202C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 690,
    cy: 370.088,
    rx: 709.022,
    ry: 56.7178,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 690,
    cy: 718.088,
    rx: 709.022,
    ry: 56.7178,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4204_47040",
    x1: 690,
    y1: -253.194,
    x2: 690,
    y2: 899.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170984,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523118,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopOpacity: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.45efc5e6c563d21a4a35d717d3917f93.svg";
export { ForwardRef as ReactComponent };